import datapoints from './datapoints';
import createItemContextsForDeleteStoreUpdate from './helpers/createItemContextsForDeleteStoreUpdate';
import restoreItemService from '../services/restoreItemService';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { handleServiceError } from 'owa-service-error';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
var RestoreItemActionName = 'RestoreItem';
/**
 * Restore items action
 * @param rowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param state the RestoreItemState which contains the original table view
 * @return the action response
 */
export default select({
    originalTableView: function (itemRowKeys, tableViewId) {
        return listViewStore.tableViews.get(tableViewId);
    },
})(action(RestoreItemActionName, datapoints.restoreItemsDatapoint)(function restoreItems(itemRowKeys, tableViewId, state) {
    var itemIdStrings = getRowIdsFromRowKeys(itemRowKeys, tableViewId);
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = handleServiceError(RestoreItemActionName, strings.errorRestore, function () {
        // Make service request
        return restoreItemService(itemIdStrings);
    });
    // delete item from reading pane, but not undo because we are not in delete items when undoing
    var itemContexts = createItemContextsForDeleteStoreUpdate(itemIdStrings);
    deleteItemsStoreUpdate(itemContexts, state.originalTableView.tableQuery.folderId);
    return actionResponse;
}));
//# sourceMappingURL=restoreItems.js.map